import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { AddIcon } from 'tdesign-icons-react';
import { Button, Drawer, Textarea } from 'tdesign-react';

import { Add4, Expand } from '@/components/icon';

import styles from './index.module.less';

export const ChatTextComponent: React.FC<
{

  value: { q: string; a: string }[];
  btnContext: string;
  valueShow?: string;
  valueType?: 'string' | 'json';
  showDrawer?: boolean;
  labelText?: string;
  onChange: (value: { q: string; a: string }[]) => void;
  onBtnClick: (value: { q: string; a: string }[]) => void;
}
> = (props) => {
  const [visible, setVisible] = useState(false);

  const [tempV, setTempV] = useState('');

  const showVal = useMemo(() => {
    const parseVal = tempV.split('\n').map((item) => {
      if (item.includes('{{user}}:')) {
        return { key: 'q', value: item.replace('{{user}}:', '') };
      } if (item.includes('{{char}}')) {
        return { key: 'a', value: item.replace('{{char}}:', '') };
      }
      return { key: null };
    })
      .filter(item => item.key !== null) as {
      key: string;
      value: string;
    }[];
    const res: { q: string; a: string; }[] = [];
    for (let i = 0; i < parseVal.length;) {
      if ((parseVal[i]?.key === 'q')) {
        if (parseVal[i + 1]?.key === 'a') {
          res.push({ q: parseVal[i].value, a: parseVal[i + 1].value });
          i += 2;
        } else {
          res.push({ q: parseVal[i].value, a: '' });
          i += 1;
        }
      }
      if (parseVal[i]?.key === 'a') {
        res.push({ q: '', a: parseVal[i].value });
        i += 1;
      }
    }
    return res;
  }, [tempV]);

  const triggedClose = () => {
    setVisible(!visible);
  };

  const handleChange = useCallback((text: string) => {
    setTempV(text);
  }, []);

  const handleInsertFormatText = useCallback(() => {
    setTempV(`${tempV}{{user}}: Hello!\n{{char}}: Hi {{user}}, I'm {{char}}.\n`);
  }, [tempV]);

  useEffect(() => {
    props.onChange(showVal);
  }, [showVal]);

  useEffect(() => {
    if (tempV.trim().length === 0 && (props.value || []).length > 0) {
      const val = props.value.map(({ q, a }) => `${!q ? '' : `{{user}}:${q}\n`}${!a ? '' : `{{char}}:${a}\n`}`).join('');
      setTempV(val);
    }
  }, [props.value]);

  const addDom = (
    <Button block
      variant="outline"
      onClick={handleInsertFormatText}
      style={{ width: 160, marginBottom: 16 }}
      icon={
        <AddIcon />
      }>
      插入示例消息
    </Button>
  );

  return (
    <div className={styles.textWrapper}>
      <Textarea
        {...props}
        value={tempV}
        placeholder='请插入示例，例如
{{user}}: 今晚的饭菜不咸。
{{char}}: 嫌没味？你怎么不把厨房的盐都吃了？'
        onChange={handleChange}
        autosize={{ minRows: 5, maxRows: 10 }}
      />
      <div className={styles.footer}>
        <div className={styles.count}>识别出 {showVal.length} 个 对话示例</div>
        <div>
          <Button
            className={styles.button}
            theme="default"
            icon={<Add4 style={{ marginRight: 4 }} />}
            onClick={handleInsertFormatText}
          >
            插入示例消息
          </Button>
          <Button
            className={styles.button}
            theme="default"
            icon={<Expand style={{ marginRight: 4 }} />}
            onClick={triggedClose}
          >
            展开
          </Button>
        </div>
      </div>
      <Drawer header={props.labelText || ''} size={'600px'} zIndex={3000} visible={visible} onClose={triggedClose} footer={false} destroyOnClose>
        <div className={styles.fixed}>{addDom}</div>
        <div className={styles.contentDrawer}>
          <Textarea
            className={styles['custom-textarea']}
            {...props}
            autosize={{ minRows: 10 }}
            value={tempV}
            onChange={handleChange}
          />
        </div>
      </Drawer>
    </div>
  );
};
